export const view04ImageOptions = {
  angle: 'View04',
  staticOptions: {
    BowSprit: 1,
    HullTreatment: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: 'BathingPlatform'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43/views/View04.js